<template>
    <main class="DescuentosView-MAIN DISPLAY">
    <main class="INNER-MARGIN">

        <!-- banner -->
        <div ref="sliderBanner" class="general-slider sliderBanner">
            <a v-for="(item, index) in sliders.Banner.content" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.cupon_id">
                <img :src="item.banner_url">
            </a>
        </div>
        <div class="slider-buttons">
            <button
                v-for="(item, index) in sliders.Banner.content" :key="index"
                @click="setSliderIndex('Banner', index)"
                :class="`active-btn-${index == sliders.Banner.current}`"
            >
            </button>
        </div>

        <!-- beneficios por marca -->
        <h3>Beneficios por marca</h3>
        
        <div class="beneficios-por-marca">
            <!--<a v-for="(item, index) in cuponesMarca" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.cupon_id">
                <img :src="item.url_logo">
            </a>-->
            <img v-for="(item, index) in cuponesMarca" :key="index" :src="item.url_logo" @click="setCuponesPorMarca(item)"  @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/logos/LOGO%20NULL.png';}"/>
        </div>

        <!--<br/>
        <div class="cupones-por-cada-marca">
            <a v-for="(item, index) in cuponesPorCadaMarca" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.cupon_id">
                <img :src="item.url_banner">
            </a>
        </div>-->

        <!-- lo mejor calificado -->
        <section class="section-lo-mejor-calificado">
            <h3>Lo mejor calificado</h3>
            <div class="lo-mejor-calificado" ref="loMejorCalificado">
                <!--<a v-for="(item, index) in cuponesCalificado" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.cupon_id">
                    <img :src="item.url_banner">
                </a>-->
                <a v-for="(item, index) in cuponesPorCadaMarca" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner" @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png';}"/>
                </a>
            </div>
        </section>

        <br/>
        <br/>

    </main>
    </main>
</template>

<script>
export default {
    name: 'DescuentosView',
    data(){
        return{
            sliders: {
                Banner: {
                    content: [
                        require('../assets/examples/descuentos1.png'),
                        require('../assets/examples/descuentos1.png'),
                        require('../assets/examples/descuentos1.png')
                    ],
                    current: 0,
                    interval: undefined,
                }
            },
            cuponesMarca: [],
            cuponesPorCadaMarca: [],
            cuponesCalificado: [],
        }
    },
    methods: {
        getFrontURL(){
			return window.location.origin;
		},

        async getBanners(){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/banners", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: "1"
                    })
                });
                const result = await response.json();
                this.sliders.Banner.content = result.data;   
                this.startSlider('Banner');
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },

        startSlider(slider_){
            const slider = this.$refs[`slider${slider_}`];
            const num = this.sliders[slider_].content.length;
            const w = slider.offsetWidth;
            
            setInterval(()=>{
                if(this.sliders[slider_].current >= num-1){
                    this.sliders[slider_].current = 0;
                }else{
                    this.sliders[slider_].current++;
                }
                slider.scroll(w*this.sliders[slider_].current, 0);        
            }, 4000);
        },

        setSliderIndex(slider_, index_){
            const slider = this.$refs[`slider${slider_}`];
            const w = slider.offsetWidth;
            
            this.sliders[slider_].current = index_;
            slider.scroll(w*this.sliders[slider_].current, 0);
            console.log(index_, index_*this.sliders[slider_].current)
        },

        async getCuponesMarca(){
            const response = await fetch("https://promo-colaboradores.ideeo.mx/api/cupones-marca", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    usuario_id: "1"
                })
            });
            const result = await response.json();
            this.cuponesMarca = result.data;
        },

        async getLoMejorCalificado(){
            const response = await fetch("https://promo-colaboradores.ideeo.mx/api/cupones-calificacion", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    usuario_id: "1"
                })
            });
            const result = await response.json();
            this.cuponesCalificado = result.data;
        },

        async setCuponesPorMarca(cupon){
            const response = await fetch("https://promo-colaboradores.ideeo.mx/api/cupones-marca-grupo?marca_grupo=" + cupon.marca_grupo, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const result = await response.json();
            console.log("result de setCUponesPorMarca", result)
            this.cuponesPorCadaMarca = result.data;
            setTimeout(() => {
                this.$refs.loMejorCalificado.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end' // Options: 'start', 'center', 'end', 'nearest'
                });
            }, 80);
        }
    },
    mounted(){
        this.getBanners();
        this.getCuponesMarca();
        this.getLoMejorCalificado();
    }
}
</script>

<style scoped>
.DescuentosView-MAIN{
    background-color: #fffaee;
    font-family: 'Benton Sans BBVA book';
    color: #0D2F6E;
}

*{
    scroll-behavior: smooth !important;
}

h3, .INNER-MARGIN > p{
    width: 100%;
    text-align: center;
}

h3{
    font-family: 'Benton Sans BBVA bold';
}

.INNER-MARGIN > p{
    margin-top: -1.5ch;
}

/* slider Banner */
.sliderBanner a{
    min-width: 99.9%;
    width: 100%;
}

.sliderBanner img{
    min-width: 99.9%;
    width: 100%;
}

/* beneficios por marca */
.beneficios-por-marca{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 1ch;
}

.beneficios-por-marca img{
    width: 100%;
    cursor: pointer;
}

.cupones-por-cada-marca{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1ch;
}

.cupones-por-cada-marca img{
    width: 100%;
}

/* lo mejor calificado */
.section-lo-mejor-calificado{
    background-color: #92c8fb5f;
    border-radius: 1ch;
    padding: 2ch;
    padding-top: 0.5ch;
    margin-top: 3ch;
}

.lo-mejor-calificado{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1ch;
}

.lo-mejor-calificado img{
    width: 100%;
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .beneficios-por-marca{
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    .lo-mejor-calificado, .cupones-por-cada-marca{
        grid-template-columns: 1fr;
    }

}
</style>